import { render } from "./ClientRatings.vue?vue&type=template&id=74387e4f&ts=true"
import script from "./ClientRatings.vue?vue&type=script&lang=ts"
export * from "./ClientRatings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__